import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  FaArrowLeft,
  FaAward,
  FaTrophy,
  FaMedal,
  FaCalendarAlt,
  FaChartBar,
  FaLightbulb,
  FaShieldAlt
} from 'react-icons/fa';
import PageTemplate from '../../components/Common/PageTemplate';

const AsaInternationalDataQuest2025 = () => {
  const pageTitle = "ASA International Data Quest 2025 Çifte Türkiye Birinciliği";
  const pageSubtitle = "Hacettepe Üniversitesi İstatistik Bölümü Öğrencilerinin Büyük Başarısı";

  const [selectedImage, setSelectedImage] = useState(null);

  // Sayfa yüklendiğinde en üste kaydır
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Takım bilgileri
  const teams = [
    {
      category: "Best Statistical Insight",
      categoryIcon: FaChartBar,
      members: [
        { name: "Ahmed Önder Akkaya" },
        { name: "Atasagun Yılmaz" },
        { name: "Taner Yeşilova" },
        { name: "Tuana Çerçi" }
      ],
      gradient: "from-blue-500 to-indigo-600",
      bgGradient: "from-blue-50 to-indigo-50"
    },
    {
      category: "Best Consideration of Ethics",
      categoryIcon: FaShieldAlt,
      members: [
        { name: "Gökdeniz Yılmaz" },
        { name: "Mehmet Furkan Yalçın" },
        { name: "Oğulcan Özer" }
      ],
      gradient: "from-green-500 to-emerald-600",
      bgGradient: "from-green-50 to-emerald-50"
    }
  ];

  // Fotoğraf galerisi
  const images = [
    { url: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/asainternational1.jpg", alt: "ASA International Data Quest 2025 - Takım 1" },
    { url: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/asainternational2.jpg", alt: "ASA International Data Quest 2025 - Takım 2" },
    { url: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/asainternational3.jpg", alt: "ASA International Data Quest 2025 - Takım 3" },
    { url: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/asainternational4.jpg", alt: "ASA International Data Quest 2025 - Takım 4" },
    { url: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/asainternational5.jpg", alt: "ASA International Data Quest 2025 - Takım 5" },
    { url: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/asainternational6.jpg", alt: "ASA International Data Quest 2025 - Takım 6" }
  ];

  return (
    <PageTemplate
      title={pageTitle}
      subtitle={pageSubtitle}
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        {/* Ana İçerik Kartı */}
        <div className="bg-white p-4 sm:p-6 md:p-8 lg:p-12 rounded-2xl md:rounded-3xl shadow-2xl -mt-16 relative z-10 mb-12 md:mb-16 overflow-hidden">
          {/* Dekoratif arka plan */}
          <div className="absolute top-0 right-0 w-64 h-64 md:w-96 md:h-96 bg-gradient-to-br from-blue-50 to-purple-50 rounded-full blur-3xl opacity-30 -z-10"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 md:w-96 md:h-96 bg-gradient-to-tr from-green-50 to-blue-50 rounded-full blur-3xl opacity-30 -z-10"></div>

          {/* Tarih ve Kategori */}
          <div className="flex flex-wrap items-center gap-2 sm:gap-3 md:gap-4 mb-6 md:mb-10 pb-4 md:pb-8 border-b border-gray-100">
            <div className="flex items-center space-x-2 px-3 sm:px-4 md:px-5 py-2 md:py-2.5 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-full border border-blue-200 shadow-sm hover:shadow-md transition-shadow">
              <FaCalendarAlt className="text-blue-600 text-xs sm:text-sm" />
              <span className="text-blue-700 font-semibold text-xs sm:text-sm">21 Kasım 2025</span>
            </div>
            <div className="flex items-center space-x-2 px-3 sm:px-4 md:px-5 py-2 md:py-2.5 bg-gradient-to-r from-purple-50 to-violet-50 rounded-full border border-purple-200 shadow-sm hover:shadow-md transition-shadow">
              <FaAward className="text-purple-600 text-xs sm:text-sm" />
              <span className="text-purple-700 font-semibold text-xs sm:text-sm">Uluslararası Yarışma</span>
            </div>
          </div>

          {/* Ana Haber İçeriği */}
          <div className="max-w-none mb-8 md:mb-12">
            <div className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 p-4 sm:p-6 md:p-8 lg:p-10 rounded-2xl md:rounded-3xl border-l-4 border-blue-500 shadow-lg mb-6 md:mb-10">
              <div className="flex items-start space-x-2 sm:space-x-3 md:space-x-4 mb-4 md:mb-6">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                    <FaTrophy className="text-lg sm:text-xl md:text-2xl text-white" />
                  </div>
                </div>
                <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-gray-800 leading-tight">
                  Uluslararası Başarı
                </h2>
              </div>

              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-700 mb-4 md:mb-6">
                <span className="font-bold text-blue-700">American Statistical Association (ASA)</span> tarafından düzenlenen
                <span className="font-semibold text-indigo-700"> "ASA International Data Quest 2025"</span> yarışmasında,
                Fakültemiz <span className="font-bold text-purple-700">İstatistik Bölümü öğrencileri</span> büyük bir başarıya imza atmıştır.
              </p>

              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-700">
                Bölümümüzü temsilen yarışmaya katılan <span className="font-bold text-green-700">iki takımımız</span>,
                iki farklı kategoride <span className="font-bold text-red-600">Türkiye Birincisi</span> olarak bizleri gururlandırmıştır.
              </p>
            </div>

            {/* Elde Edilen Dereceler Bilgisi */}
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-4 sm:p-6 md:p-8 rounded-2xl md:rounded-3xl border border-amber-200 shadow-md mb-6 md:mb-10">
              <div className="flex items-center space-x-2 sm:space-x-3 mb-4 md:mb-6">
                <FaLightbulb className="text-2xl sm:text-2xl md:text-3xl text-amber-600 flex-shrink-0" />
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800">Uluslararası Arenaya Doğru</h3>
              </div>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
                Elde ettikleri derecelerle <span className="font-bold text-amber-700">uluslararası arenada ülkemizi temsil etme hakkı</span> kazanan
                öğrencilerimiz, yarışmanın bir sonraki etabında <span className="font-semibold text-blue-700">Brezilya ve Endonezya</span> takımları
                ile uluslararası düzeyde yarışacaklardır.
              </p>
            </div>
          </div>
        </div>

        {/* Takımlar Bölümü */}
        <div className="mb-12 md:mb-16">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-800 mb-3 md:mb-4 tracking-tight px-2">
              🏆 Türkiye Birincisi Takımlarımız
            </h2>
            <div className="w-24 sm:w-28 md:w-32 h-1 md:h-1.5 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 mx-auto rounded-full mb-4 md:mb-6"></div>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
              İki farklı kategoride ülkemizi gururlandıran başarılı öğrencilerimiz
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
            {teams.map((team, teamIndex) => (
              <div
                key={teamIndex}
                className={`group relative bg-gradient-to-br ${team.bgGradient} p-4 sm:p-6 md:p-8 rounded-2xl md:rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 border-2 border-transparent hover:border-gray-200 overflow-hidden`}
              >
                {/* Dekoratif arka plan */}
                <div className={`absolute top-0 right-0 w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 bg-gradient-to-br ${team.gradient} opacity-10 rounded-full blur-3xl group-hover:opacity-20 transition-opacity duration-500`}></div>

                <div className="relative">
                  {/* Kategori Başlığı */}
                  <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4 mb-4 sm:mb-6 md:mb-8">
                    <div className={`flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br ${team.gradient} rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                      <team.categoryIcon className="text-lg sm:text-xl md:text-2xl text-white" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center space-x-1 sm:space-x-2 mb-1">
                        <FaTrophy className="text-yellow-500 text-base sm:text-lg md:text-xl flex-shrink-0" />
                        <span className="text-xs sm:text-sm font-bold text-yellow-600 uppercase tracking-wide">Türkiye Birincisi</span>
                      </div>
                      <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 leading-tight break-words">
                        {team.category}
                      </h3>
                    </div>
                  </div>

                  {/* Takım Üyeleri */}
                  <div className="space-y-2 sm:space-y-3">
                    {team.members.map((member, memberIndex) => (
                      <div
                        key={memberIndex}
                        className="bg-white/80 backdrop-blur-sm p-3 sm:p-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 border border-gray-100"
                      >
                        <div className="flex items-center space-x-2 sm:space-x-3">
                          <div className={`flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 bg-gradient-to-br ${team.gradient} rounded-full flex items-center justify-center text-white font-bold shadow-md text-sm sm:text-base`}>
                            {memberIndex + 1}
                          </div>
                          <p className="text-gray-800 font-semibold text-sm sm:text-base md:text-lg break-words flex-1">{member.name}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Fotoğraf Galerisi */}
        <div className="mb-12 md:mb-16">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-800 mb-3 md:mb-4 px-2">📸 Galeri</h2>
            <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-pink-500 to-purple-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3 md:gap-4">
            {images.map((image, index) => (
              <div
                key={index}
                className="group relative aspect-square overflow-hidden rounded-xl md:rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-2 sm:bottom-3 md:bottom-4 left-2 sm:left-3 md:left-4 text-white font-semibold text-xs sm:text-sm">
                    Fotoğrafı Büyüt
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Tebrik Mesajı */}
        <div className="mb-12 md:mb-16">
          <div className="bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 p-6 sm:p-8 md:p-10 lg:p-14 rounded-2xl md:rounded-3xl border-2 border-green-200 shadow-2xl text-center relative overflow-hidden">
            {/* Dekoratif elementler */}
            <div className="absolute top-0 left-0 w-32 h-32 md:w-40 md:h-40 bg-green-200 rounded-full blur-3xl opacity-20"></div>
            <div className="absolute bottom-0 right-0 w-32 h-32 md:w-40 md:h-40 bg-emerald-200 rounded-full blur-3xl opacity-20"></div>

            <div className="relative max-w-4xl mx-auto">
              <div className="flex justify-center mb-6 md:mb-8">
                <div className="w-20 h-20 sm:w-22 sm:h-22 md:w-24 md:h-24 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center shadow-2xl animate-pulse">
                  <FaMedal className="text-3xl sm:text-3xl md:text-4xl text-white" />
                </div>
              </div>

              <h3 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-800 mb-4 md:mb-6 px-2">
                🎉 Tebrikler!
              </h3>

              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-700 leading-relaxed mb-6 md:mb-8 font-medium px-2">
                Fakülte olarak <span className="font-bold text-green-700">öğrencilerimizi başarılarından dolayı tebrik ediyor</span>,
                ülkemizi ve üniversitemizi temsil edecekleri <span className="font-bold text-emerald-700">uluslararası finalde</span> kendilerine
                <span className="font-bold text-teal-700"> başarılar diliyoruz</span>.
              </p>

              <div className="inline-block px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 md:py-3 bg-white rounded-full shadow-lg">
                <p className="text-gray-700 font-bold text-sm sm:text-base md:text-lg">Fen Fakültesi Dekanlığı</p>
              </div>

              <div className="mt-6 sm:mt-8 md:mt-10 flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4">
                {['🏆', '🎓', '📊', '🌟', '💡', '🚀'].map((emoji, index) => (
                  <div
                    key={index}
                    className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-white rounded-xl md:rounded-2xl shadow-lg flex items-center justify-center text-lg sm:text-xl md:text-2xl hover:scale-125 hover:rotate-12 transition-all duration-300"
                    style={{ animationDelay: `${index * 100}ms` }}
                  >
                    {emoji}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Geri Dön Butonu */}
        <div className="text-center pb-6 md:pb-8">
          <Link
            to="/haberler"
            className="group inline-flex items-center px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 text-white font-bold rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-gray-400"
          >
            <FaArrowLeft className="mr-2 sm:mr-3 h-5 w-5 sm:h-6 sm:w-6 group-hover:-translate-x-2 transition-transform duration-300" />
            <span className="text-sm sm:text-base md:text-lg">Tüm Haberlere Geri Dön</span>
          </Link>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors z-10"
            onClick={() => setSelectedImage(null)}
          >
            ×
          </button>
          <img
            src={selectedImage.url}
            alt={selectedImage.alt}
            className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
          />
        </div>
      )}
    </PageTemplate>
  );
};

export default AsaInternationalDataQuest2025;
